<div class="options-container" id="div_options-container_ad26f444">
  <!--PAGE TITLE-->
  <div class="title" id="div_title_f6a29ee9">Mechanical Options</div>

  <!--PARAGRAPH-->
  <p
    title=" Please select your preferred attributes"
    class="options-paragraph"
    id="p_options-paragraph_dcd9687f"
  >
    Please select your preferred attributes below. While selected options are
    not guaranteed and may limit available railcar results, your account manager
    will work with you to find the right railcars.
  </p>

  <div [ngSwitch]="selectedCarType" id="div_81b6c24e">
    <div *ngSwitchCase="enum_car_type.COVERED_HOPPER" id="div_ef7af50d">
      <app-hopper-cart-options></app-hopper-cart-options>
    </div>

    <div *ngSwitchCase="enum_car_type.PRESSURE_TANK" id="div_376d9a46">
      <app-pressure-cart-options></app-pressure-cart-options>
    </div>

    <div *ngSwitchCase="enum_car_type.GENERAL_SERVICE" id="div_ad8a71f2">
      <app-general-cart-options></app-general-cart-options>
    </div>
  </div>
</div>
